<template>
  <div>
    <i-modal
      :value="isShow"
      @on-cancel="cancel"
      :mask="false"
      :closable="closable"
      :mask-closable="false"
      class-name="ivu-modal-mask-diy"
      :styles="{ position: 'fixed', width: 'inherit!important', top: '60px', button: 0, left: '190px', right: 0 }"
      fullscreen
      footer-hide
    >
      <div slot="header" class="title">
        <h2>编辑</h2>
      </div>
      <div class="content">
        <div>
          <i-row class="a-row" align="middle">
            <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
              <span class="text">标题：</span>
            </i-col>
            <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
              <i-input v-model="title" class="col-input" type="text"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle">
            <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
              <span class="text">发布时间：</span>
            </i-col>
            <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
              <i-datePicker
                type="datetime"
                v-model="published_time"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="Select date and time"
                style="width: 200px"
              ></i-datePicker>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle">
            <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
              <span class="text">置顶：</span>
            </i-col>
            <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
              <i-switch v-model="top" />
              {{ top ? "是" : "否" }}
            </i-col>
          </i-row>
          <div v-for="(item, index) in currentChannelAttr" :key="index">
            <i-row class="a-row" align="middle" v-if="item.type.split('__')[1] === 'string'">
              <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                <span class="text">{{ item.name }}：</span>
              </i-col>
              <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                <i-input class="col-input" type="text" v-model="channelAttr[item.type]"></i-input>
              </i-col>
            </i-row>
            <i-row class="a-row" align="middle" v-if="item.type.split('__')[1] === 'textarea'">
              <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                <span class="text">{{ item.name }}：</span>
              </i-col>
              <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                <i-input class="col-input" type="textarea" :rows="4" v-model="channelAttr[item.type]"></i-input>
              </i-col>
            </i-row>
            <i-row class="a-row" align="middle" v-else-if="item.type.split('__')[1] === 'file'">
              <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                <span class="text">{{ item.name }}：</span>
              </i-col>
              <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                <input
                  v-if="item.type.split('__')[2] === 'picture'"
                  type="file"
                  accept="image/*"
                  @change="uploadFile($event, item.type.split('__')[2], item.type, channelAttr)"
                  :id="item.type"
                />
                <input
                  v-if="item.type.split('__')[2] === 'video'"
                  type="file"
                  accept="video/*"
                  @change="uploadFile($event, item.type.split('__')[2], item.type, channelAttr)"
                  :id="item.type"
                />
                <input
                  v-if="item.type.split('__')[2] === 'pdf'"
                  type="file"
                  accept=".pdf"
                  @change="uploadFile($event, item.type.split('__')[2], item.type, channelAttr)"
                  :id="item.type"
                />
              </i-col>
            </i-row>
            <i-row class="a-row" align="middle" v-if="item.type.split('__')[1].indexOf('enum') !== -1">
              <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                <span class="text">{{ item.name }}：</span>
              </i-col>
              <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                <i-select v-model="channelAttr[item.type]" filterable>
                  <i-option v-for="(_item, index) in item.value" :value="_item" :key="index">{{ _item }}</i-option>
                </i-select>
              </i-col>
            </i-row>
          </div>
          <div v-if="editData.template">
            <div v-for="(item, index) in currentTemplateAttr" :key="index">
              <i-row class="a-row" align="middle" v-if="item.split('__')[1] === 'string'">
                <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                  <span class="text">{{ item.split("__")[2] }}：</span>
                </i-col>
                <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                  <i-input class="col-input" type="text" v-model="templateAttr[item]"></i-input>
                </i-col>
              </i-row>
              <i-row class="a-row" align="middle" v-else-if="item.split('__')[1] === 'file'">
                <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                  <span class="text">{{ item.split("__")[3] }}：</span>
                </i-col>
                <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                  <input
                    v-if="item.split('__')[2] === 'picture'"
                    type="file"
                    accept="image/*"
                    @change="uploadFile($event, item.split('__')[2], item, templateAttr)"
                    :id="item"
                  />
                  <input
                    v-if="item.split('__')[2] === 'video'"
                    type="file"
                    accept="video/*"
                    @change="uploadFile($event, item.split('__')[2], item, templateAttr)"
                    :id="item"
                  />
                  <input
                    v-if="item.split('__')[2] === 'pdf'"
                    type="file"
                    accept=".pdf"
                    @change="uploadFile($event, item.split('__')[2], item, templateAttr)"
                    :id="item"
                  />
                </i-col>
              </i-row>
            </div>
          </div>
          <div v-show="!editData.template">
            <i-row class="a-row" align="top">
              <i-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" :xxl="2" offset="1">
                <span class="text">自由编辑：</span>
              </i-col>
              <i-col :xs="14" :sm="16" :md="17" :lg="18" :xl="19" :xxl="20">
                <ckeditor-cmp :content="content" :is-show="isShow" :cms-url="cmsUrl"  ref="editContentCkeditor"/>
              </i-col>
            </i-row>
          </div>
        </div>
        <i-row class="a-row" align="middle">
          <i-col offset="1" span="22" align="center">
            <i-button type="success" class="article-button" @click="editContent">
              提交
            </i-button>
          </i-col>
        </i-row>
      </div>
    </i-modal>
  </div>
</template>
<script>
import CkeditorCmp from "./CkeditorCmp"
import { baseConfigMixin, uploadFileMixin } from "../mixin"
export default {
  name: "EditContentModal",
  components: {
    CkeditorCmp,
  },
  mixins: [uploadFileMixin, baseConfigMixin],
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default() {
        return {}
      },
    },
    channel: {
      type: String,
      default: "",
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: "",
      top: false,
      channelAttr: {},
      templateAttr: {},
      content: "",
      currentChannelAttr: [],
      currentTemplateAttr: [],
      isFreeEdit: false,
      imageLoading: false,
      id: "",
      published_time: "",
    }
  },
  methods: {
    init() {
      this.title = ""
      this.top = false
      this.templateAttr = {}
      this.content = ""
      this.currentChannelAttr = []
      this.currentTemplateAttr = []
      this.published_time = ""
    },
    cancel() {
      this.init()
      this.$emit("cancel")
    },
    //获取频道详情
    async getChannelDetail() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/channel/get",
          params: {
            name: self.channel,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.isFreeEdit = res.data.data.isFreeEdit
          self.channelAttr = {}
          self.currentChannelAttr = []
          self.templateAttr = {}
          res.data.data.attributes.forEach((item) => {
            self.currentChannelAttr.push(item)
            self.channelAttr[item.name] = ""
          })
          res.data.data.templates.forEach((item) => {
            item.attributes.forEach((_item) => {
              self.templateAttr[_item] = ""
            })
          })
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    async editContent() {
      const self = this
      const content = this.$refs.editContentCkeditor.getContent()
      if (this.imageLoading) {
        this.$Message.error("请等待文件上传完成！")
        return
      }
      if (this.title === "") {
        this.$Message.error("请填写标题！")
        return
      }
      if (!this.published_time) {
        this.published_time = this.$moment().format("YYYY-MM-DD HH:mm:ss")
      }
      else {
        this.published_time = this.$moment(this.published_time).format("YYYY-MM-DD HH:mm:ss")
      }
      for (let item in this.channelAttr) {
        if (this.channelAttr[item] === "") {
          self.$Message.error("请填写" + item + "!")
          return
        }
      }
      if (this.editData.template) {
        for (let item in this.templateAttr) {
          if (this.templateAttr[item] === "") {
            self.$Message.error("请填写" + item + "!")
            return
          }
        }
      } else {
        if (content === "" || content === undefined) {
          self.$Message.error("请填写文章内容!")
          return
        }
      }
      self.showLoading = true
      let xData = {
        cid: self.id,
        title: self.title,
        attributes: self.channelAttr,
        top: self.top,
        published_time: self.published_time,
      }
      if (this.editData.template) {
        xData["template_attr"] = self.templateAttr
      } else {
        xData["content"] = content
      }
      try {
        const res = await self.axios({
          method: "post",
          url: this.cmsUrl + "api/content/content/edit",
          data: xData,
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          self.$Message.success("修改成功！")
          self.$emit("success")
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
  },
  watch: {
    async isShow() {
      if (!this.isShow) {
        this.init()
      } else {
        await this.getChannelDetail()
        this.title = this.editData.title
        this.top = this.editData.top
        if (this.editData.template) {
          this.currentTemplateAttr = []
          this.templateAttr = {}
          for (let item in this.editData.template_attr) {
            this.currentTemplateAttr.push(item)
            this.templateAttr[item] = this.editData.template_attr[item]
          }
        } else {
          this.content = this.editData.content
        }
        this.channelAttr = {}
        for (let item in this.editData.attributes) {
          if (item.indexOf("cms__file") === -1) {
            this.channelAttr[item] = this.editData.attributes[item]
          }
        }
        this.published_time = this.editData.published_time
        this.id = this.editData.id
      }
    },
  },
}
</script>
<style scoped>
.title {
  text-align: center;
}
.a-row {
  margin: 20px 0;
}
</style>
<style>
.ck-content {
  height: 500px;
}
.ivu-modal-mask-diy {
  z-index: 9!important;
}
</style>
